require("./bootstrap");

import "lazysizes";

// SCROLL TO
window.goTo = function (target) {
    event.preventDefault();
    var el = document.getElementById(target);
    if (el != undefined) {
        var headerOffset = document.querySelector("header").offsetHeight;

        setTimeout(function () {
            var elementPosition = el.getBoundingClientRect().top;

            if (window.innerWidth < 1279.98) {
                var offsetPosition = elementPosition - headerOffset - 60;
            } else {
                var offsetPosition = elementPosition - headerOffset - 0;
            }

            const startPos = window.pageYOffset;

            window.scrollTo({
                top: startPos + offsetPosition,
                behavior: "smooth",
            });
        }, 250);
    }
};

window.addEventListener("DOMContentLoaded", (event) => {
    let hash = window.location.hash;
    if (hash != "") {
        window.goTo("bloc-" + hash.substr(1));
    }
});
